
import { TaskDateType } from '@/types/entities'
import { defineComponent, PropType } from 'vue'
import DatePicker from 'vue3-date-time-picker'
import 'vue3-date-time-picker/dist/main.css'

interface day {
  i: number
  d: string
}

export default defineComponent({
  props: {
    date: {
      type: Object as PropType<TaskDateType>,
      required: true,
      default: () => ({ startDate: '', dueDate: new Date() })
    }
  },
  components: {
    DatePicker
  },
  inject: ['task', 'list', 'updateListTask'],
  data () {
    return {
      defaultDate: new Date(),
      dueDateCheckBox: true,
      hasRange: true,
      days: [
        { i: 0, d: 'Sun' },
        { i: 1, d: 'Mon' },
        { i: 2, d: 'Tue' },
        { i: 3, d: 'Wed' },
        { i: 4, d: 'Thu' },
        { i: 5, d: 'Fri' },
        { i: 6, d: 'Sat`' }
      ]
    }
  },
  computed: {
    formatted () {
      const isArray = Array.isArray(this.defaultDate)
      return {
        startDate: new Intl.DateTimeFormat('en-US').format(isArray ? this.defaultDate[0] : new Date()),
        dueDate: new Intl.DateTimeFormat('en-US').format(isArray ? this.defaultDate[1] : this.defaultDate),
        dueTime: new Intl.DateTimeFormat('en-US', { hour12: true, hour: 'numeric', minute: 'numeric' }).format(
          isArray ? this.defaultDate[1] : this.defaultDate
        )
      }
    }
  },
  watch: {
    hasRange: {
      handler (v) {
        if (v) this.defaultDate = [new Date(), new Date(this.date.dueDate)]
        // else this.defaultDate = new Date(this.date.dueDate)
      }
    }
  },
  mounted () {
    if (this.date.startDate) {
      this.hasRange = true
      this.defaultDate = [new Date(this.date.startDate), new Date(this.date.dueDate)]
    } else {
      this.hasRange = false
      if (this.date.dueDate) {
        this.defaultDate = new Date(this.date.dueDate)
      }
    }
  },
  methods: {
    handleDefaultDateChange (date: Array<Date> | Date) {
      this.defaultDate = date
    },
    getDay (day: number) {
      return this.days.find((d: day) => d.i === day).d
    },
    async handleDateChange () {
      let payload = {}
      if (this.hasRange) {
        payload = { date: { startDate: this.defaultDate[0], dueDate: this.defaultDate[1] } }
      } else {
        payload = { date: { dueDate: new Date(this.defaultDate) } }
      }
      this.$emit('dateChange', payload)
    }
  }
})
